import { Box } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import { Spinner } from '../../App/Components'
import { useAppSelector } from '../../App/Hooks/reduxHooks'
import { Button } from '../../Common/Button'
import { Layout } from '../../Common/Layout'
import { H1, Text } from '../../Common/Typography'

import { AbsenceList } from './component/AbsenceList'
import { PersonSelect } from './component/PersonSelect'
import { useGetAbsenceListQuery } from './util/useAbsenceQuery'

export const AbsencesOverviewPage = () => {
  const params = useParams<{ personUuid?: string }>()
  const [personUuid, setPersonUuid] = useState<string | undefined>(
    params.personUuid,
  )
  const { data, status, isRefetching } = useGetAbsenceListQuery()
  const selectedPerson = useAppSelector(state =>
    state.users.list.find(person => person.uuid === personUuid),
  )

  const { t } = useTranslation()
  const history = useHistory()
  const handlePersonUuid = (uuid: string) => {
    history.replace(`/hr/absences/${uuid}`)
    setPersonUuid(uuid)
  }

  if (status === 'pending') return <Spinner />

  if (status === 'error') return <p>something went wrong</p>

  return (
    <Layout>
      <Box m={3} mb={1} p={2}>
        <H1> {t('Absence')}</H1>
      </Box>
      <Box m={2} p={1}>
        <Box m={1} p={1}>
          <Text>{t('Please select a person')}</Text>
        </Box>
        <Box m={1} p={1}>
          <PersonSelect
            width={500}
            onChange={handlePersonUuid}
            value={personUuid}
          />
        </Box>
      </Box>
      {!!selectedPerson && (
        <Box m={3} mb={0} p={2}>
          <Button
            onClick={() => {
              console.log(
                'Add absence for',
                selectedPerson.uuid,
                'navigate to add/ uuid',
              )
              history.push(`/hr/absences/add/${selectedPerson.uuid}`)
            }}>
            {`${t('Add absence for')} ${selectedPerson.firstName} ${
              selectedPerson.lastName ?? ''
            }`}
          </Button>
        </Box>
      )}
      {!!selectedPerson && (
        <AbsenceList
          person={selectedPerson}
          absences={data}
          isRefetching={isRefetching}
        />
      )}
    </Layout>
  )
}
